import React from 'react'

import { FormEditPanel } from 'react-form-editor'
import 'react-form-editor/dist/index.css'

const App = () => {
  return <FormEditPanel />
}

export default App
